<div class="bo-dialog site-build">
  <header class="bo-dialog__head">
    <span class="bo-dialog__icon" [class.bo-dialog__icon--green]="isComplete" [class.bo-dialog__icon--amber]="trackingError"><i class="bi" [ngClass]="isComplete ? 'bi-check2-circle' : trackingError ? 'bi-wifi-off' : 'bi-shop'" aria-hidden="true"></i></span>
    <div class="bo-dialog__heading"><h2 id="site-build-title" tabindex="-1" ngbAutofocus>{{ (isComplete ? 'site_setup_ready_heading' : 'site_setup_build_heading') | translate }}</h2><p>{{ siteName || ('site_setup_your_shop' | translate) }}</p></div>
    <span class="site-build__step-count" *ngIf="!isComplete && !isStarting && !trackingError">{{ 'site_setup_step_count' | translate:{ current: currentStepIndex + 1, total: steps.length } }}</span>
  </header>

  <div class="bo-dialog__body">
    <app-site-setup-illustration [stage]="illustrationStage" [shopName]="siteName" [paused]="trackingError" [animated]="true"></app-site-setup-illustration>
    <section class="site-build__current" role="status" aria-live="polite" aria-atomic="true">
      <h3 [class.is-error]="trackingError">{{ currentTitleKey | translate }}</h3>
      <p>{{ currentDetailKey | translate }}</p>
      <bdi *ngIf="isComplete && shopAddress" dir="ltr" class="site-build__address"><i class="bi bi-globe2" aria-hidden="true"></i>{{ shopAddress }}</bdi>
    </section>
    <div class="site-build__rail" [class.is-starting]="isStarting" [class.is-paused]="trackingError" aria-hidden="true">
      <span *ngFor="let step of steps; let index = index" [class.is-active]="index === currentStepIndex" [class.is-done]="index < currentStepIndex"><i></i></span>
    </div>
    <ol class="site-build__steps" [attr.aria-label]="'site_setup_steps_label' | translate">
      <li *ngFor="let step of steps; let index = index" [class.is-current]="index === currentStepIndex" [class.is-done]="index < currentStepIndex" [class.is-paused]="trackingError" [attr.aria-current]="index === currentStepIndex ? 'step' : null">
        <span class="site-build__step-icon"><i class="bi" [ngClass]="step.icon" aria-hidden="true"></i></span>
        <span class="site-build__step-label">{{ step.title | translate }}</span>
        <span class="site-build__step-status">
          <ng-container *ngIf="index === currentStepIndex; else inactiveStep">
            <span *ngIf="!trackingError" class="site-build__dots" aria-hidden="true"><i></i><i></i><i></i></span>
            {{ (trackingError ? 'site_setup_step_paused' : 'site_setup_step_active') | translate }}
          </ng-container>
          <ng-template #inactiveStep>
            <ng-container *ngIf="index < currentStepIndex; else waitingStep"><i class="bi bi-check2" aria-hidden="true"></i>{{ 'site_setup_step_done' | translate }}</ng-container>
            <ng-template #waitingStep><span class="site-build__waiting-index" aria-hidden="true">0{{ index + 1 }}</span><span class="visually-hidden">{{ 'site_setup_step_waiting' | translate }}</span></ng-template>
          </ng-template>
        </span>
      </li>
    </ol>
  </div>

  <footer class="bo-dialog__foot site-build__foot">
    <ng-container *ngIf="!trackingError; else trackingActions">
      <span class="site-build__dots" aria-hidden="true"><i></i><i></i><i></i></span>
      <span>{{ (isComplete ? 'site_setup_opening' : takingLonger ? 'site_setup_taking_longer' : 'site_setup_build_note') | translate }}</span>
    </ng-container>
    <ng-template #trackingActions>
      <button type="button" class="bo-dialog__button" (click)="closeTrackingError()">{{ 'ac_close' | translate }}</button>
      <button type="button" class="bo-dialog__button bo-dialog__button--primary" (click)="retryTracking()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>{{ 'ac_retry' | translate }}</button>
    </ng-template>
  </footer>
</div>
